<template lang="pug">
#collections-tab
  spinner(v-if="settings.loading")
  div(v-else)
    b-table(
      sort-icon="chevron-up"
      :data="collections"
      :default-sort="[filters.sort.field, filters.sort.order]"
      :default-sort-direction="filters.sort.order"
      :total="pagination.total"
      :current-page="pagination.page"
      :per-page="pagination.per"
      @click="open"
      @page-change="getPage"
      @sort="sort"
      backend-pagination
      backend-sorting
      hoverable
      paginated
    )
      template(slot-scope="props")
        b-table-column(
          label="Title"
          field="title.raw"
          sortable
        ) {{ props.row.title }}
        b-table-column(
          label="Year"
          field="year"
          sortable
        )
          small(v-if="props.row.year") {{ props.row.year }}
          small.has-text-grey-light(v-else) NA
        b-table-column(
          label="Episodes"
          field="episode_count"
          sortable
        )
          small {{ props.row.episode_count }}
        b-table-column(label="Page")
          small
            a.has-text-primary(:href="`https://${account.host}/collections/${props.row.id}`" target="_blank")
              span View
              b-icon(icon="open-in-new" size="is-small")
</template>

<script>
import { mapGetters } from 'vuex';
import CollectionForm from '@/components/form/CollectionForm';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'collections-tab',
  components: {
    CollectionForm,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      collections: getters.GET_COLLECTIONS,
      filters: getters.GET_COLLECTION_FILTERS,
      mediaRefresh: getters.GET_MEDIA_REFRESH,
      mediaTab: getters.GET_MEDIA_TAB,
      mediaTags: getters.GET_MEDIA_TAGS,
    }),
    esQuery() {
      const from = this.pagination.per * (this.pagination.page - 1);
      const sort = {};
      sort[this.filters.sort.field] = this.filters.sort.order;
      const payload = {
        from,
        size: this.pagination.per,
        sort: [sort],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
            ],
          },
        },
      };
      this.mediaTags.forEach((tag) => {
        const item = {};
        switch (tag._index) {
          case 'doxa_episodes':
            // item.match = { id: tag._id };
            break;
          case 'doxa_channels':
            item.terms = { channel_ids: [tag._id] };
            break;
          case 'doxa_episode_collections':
            item.match = { id: tag._id };
            break;
          case 'doxa_speakers':
            item.terms = { speaker_ids: [tag._id] };
            break;
          default:
        }
        if (Object.entries(item).length > 0) {
          payload.query.bool.must.push(item);
        }
      });
      return payload;
    },
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      pagination: {
        page: 1,
        per: 26,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async getPage(page, skipAnimation) {
      if (!skipAnimation) this.settings.loading = true;
      this.pagination.page = page;
      const response = await this.$store.dispatch(actions.DO_SEARCH_COLLECTIONS, this.esQuery);
      this.pagination.total = response.hits.total;
      if (!skipAnimation) this.settings.loading = false;
    },
    async open(collection) {
      await this.$store.dispatch(actions.DO_GET_COLLECTION, {
        id: collection.id,
        zoom: 'artwork',
      });
      this.$buefy.modal.open({
        parent: this,
        component: CollectionForm,
        hasModalCard: true,
      });
    },
    sort(field, order) {
      this.$store.commit(mutations.SET_COLLECTION_FILTER_FIELD, {
        key: 'sort.field',
        val: field,
      });
      this.$store.commit(mutations.SET_COLLECTION_FILTER_FIELD, {
        key: 'sort.order',
        val: order,
      });
      this.getPage(1, true);
    },
    async refresh() {
      const response = await this.$store.dispatch(actions.DO_SEARCH_COLLECTIONS, this.esQuery);
      this.$store.commit(mutations.SET_MEDIA_REFRESH, false);
      this.pagination.total = response.hits.total;
    },
  },
  watch: {
    mediaRefresh(val) {
      if (val) this.refresh();
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/CollectionsTab.vue